/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadWritePermissionTypeResponse
 */
export interface ReadWritePermissionTypeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ReadWritePermissionTypeResponse
     */
    isRead?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ReadWritePermissionTypeResponse
     */
    isWrite?: boolean;
}

export function ReadWritePermissionTypeResponseFromJSON(json: any): ReadWritePermissionTypeResponse {
    return ReadWritePermissionTypeResponseFromJSONTyped(json, false);
}

export function ReadWritePermissionTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadWritePermissionTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isRead': !exists(json, 'isRead') ? undefined : json['isRead'],
        'isWrite': !exists(json, 'isWrite') ? undefined : json['isWrite'],
    };
}

export function ReadWritePermissionTypeResponseToJSON(value?: ReadWritePermissionTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isRead': value.isRead,
        'isWrite': value.isWrite,
    };
}


